/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCryptoDynamicLimits} from '../api'

 export const useQueryGetCryptoDynamicLimits = createReactQueryHook('getCryptoDynamicLimits', getCryptoDynamicLimits)
